module.exports = __webpack_public_path__ + "img/pr-2.5c050ad2.png";